import React, { useEffect, useState } from 'react';
import { WalletIcon } from 'cokitchen-icons';
import { ReactComponent as PaystackIcon } from 'assets/icons/paystack-icon.svg';
import TopupWalletCard from 'components/topup-wallet-card';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import PageHeader from 'components/base/page-header';
import useDashboardContext from 'contexts/dashboard.context';
import { formatNumber, handleApiError } from 'utils/functions';
import CurrencyInput from 'components/base/currency-input';
import { apiService } from 'services/base.service';

const GetStartedTopupwallet = () => {
  const { setIsDisabled } = useGetStartedActionsContext();
  const {
    activeCompany,
    paystackProps,
    setPaystackProps,
    paymentAmount,
    setPaymentAmount,
    activePaymentCard,
    setActivePaymentCard,
    paymentCards,
    paymentType,
    setPaymentType,
    paymentView,
    setPaymentView
  } = useDashboardContext();
  const [budget, setBudget] = useState('');
  const [loading, setLoading] = useState(false);

  const loadBudget = async () => {
    if (!activeCompany?.id) return;
    try {
      setLoading(true);
      const res = await apiService.get(`admin/recommended-deposit/${activeCompany.id}`);
      setBudget(res.data.data.total_amount);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBudget();
  }, []);

  useEffect(() => {
    setIsDisabled(
      (paymentView === 'methods' && !paymentType) || (paymentView === 'pay' && !paymentAmount)
    );
  }, [paymentView, paymentType, paymentAmount]);

  return (
    <div className='space-y-5 w-[390px]'>
      <PageHeader
        title='Top-up wallet'
        subtitle='Fund your company wallet with the total team budget for the next 30 days based on your budget settings.'
      />

      <div className='rounded-[6px] border border-[#F0EFEF] bg-[#F7F7F7] h-[128px] space-y-6 flex flex-col items-center justify-center'>
        <p className='text-gray-9 text-sm'>Your teams&apos; total budget is </p>
        <h3 className='font-semibold text-lg md:text-[32px]'>
          <span className='text-sm font-normal'> NGN </span>
          {loading ? '-' : formatNumber(budget ?? 0, { style: 'decimal' })}
        </h3>
      </div>

      <p className='text-center'>
        You may top-up your wallet with at least
        <span className='font-medium text-blue-5'> NGN 500,000 </span>
        select payment method
      </p>
      {paymentView === 'methods' ? (
        <div className='w-full flex flex-col space-y-2'>
          {(paymentCards ?? []).map((card) => (
            <TopupWalletCard
              key={card.id}
              onClick={() => {
                setPaymentType('paystack');
                setActivePaymentCard(null);
              }}
              active={paymentType === 'paystack' && activePaymentCard?.id === card.id}
              icon={<PaystackIcon />}
              description={`*** ${card.last_four_digit}`}
              title='Pay with Paystack'
            />
          ))}

          <TopupWalletCard
            onClick={() => {
              setPaymentType('paystack');
              setActivePaymentCard(null);
            }}
            active={paymentType === 'paystack'}
            icon={<WalletIcon className='w-5 h-5 text-[#00C3F7]' />}
            description='Powered by paystack'
            title='Pay with card'
          />

          <TopupWalletCard
            onClick={() => {
              setPaymentType('transfer');
              setActivePaymentCard(null);
            }}
            active={paymentType === 'transfer'}
            icon={<WalletIcon className='w-5 h-5 text-[#00C3F7]' />}
            description='Powered by bani'
            title='Pay with transfer'
          />
        </div>
      ) : (
        <div className='w-full flex flex-col gap-3'>
          <p
            onClick={() => {
              setPaymentView('methods');
            }}
            className='text-[#0080E5] text-xs cursor-pointer pb-2 self-start'>
            Back to payment methods
          </p>
          <CurrencyInput
            label='Top-up Amount'
            placeholder='500,000'
            value={paymentAmount}
            onChange={(value) => {
              setPaymentAmount(value);
              setPaystackProps({
                ...paystackProps,
                amount: +(value || 0) * 100
              });
            }}
          />
        </div>
      )}
    </div>
  );
};

export default GetStartedTopupwallet;
